import { FACULTIES, MAX_SEMESTER, MIN_SEMESTER, getFaculty } from "@clubap/shared";

export interface AcademicDraft {
  faculty: string;
  program: string;
  semester: string;
}

const SEMESTERS = Array.from(
  { length: MAX_SEMESTER - MIN_SEMESTER + 1 },
  (_, i) => MIN_SEMESTER + i,
);

interface Props {
  value: AcademicDraft;
  onChange: (next: AcademicDraft) => void;
}

/**
 * Las tres listas, en un solo sitio: las usan el perfil y el paso de bienvenida.
 * Acá vive también la regla de que cambiar de facultad borra la carrera.
 */
export function AcademicFields({ value, onChange }: Props) {
  const programs = getFaculty(value.faculty)?.programs ?? [];

  return (
    <>
      <label className="auth__field">
        Facultad
        <select
          className="join__input"
          value={value.faculty}
          onChange={(event) =>
            onChange({ ...value, faculty: event.target.value, program: "" })
          }
        >
          <option value="">Prefiero no decirlo</option>
          {FACULTIES.map((entry) => (
            <option key={entry.id} value={entry.id}>
              {entry.code} — {entry.name}
            </option>
          ))}
        </select>
      </label>

      <label className="auth__field">
        Carrera
        <select
          className="join__input"
          value={value.program}
          disabled={value.faculty === ""}
          onChange={(event) => onChange({ ...value, program: event.target.value })}
        >
          <option value="">
            {value.faculty === "" ? "Elige una facultad primero" : "Sin decir"}
          </option>
          {programs.map((entry) => (
            <option key={entry.id} value={entry.id}>
              {entry.name}
            </option>
          ))}
        </select>
      </label>

      <label className="auth__field">
        Semestre
        <select
          className="join__input"
          value={value.semester}
          onChange={(event) => onChange({ ...value, semester: event.target.value })}
        >
          <option value="">Sin decir</option>
          {SEMESTERS.map((number) => (
            <option key={number} value={number}>
              {number}
            </option>
          ))}
        </select>
      </label>
    </>
  );
}
